// extracted by mini-css-extract-plugin
module.exports = {"container":"static-chat-topbar_container__DdkJl"};